import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class Radio extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
    value: PropTypes.any,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.any,
    children: PropTypes.any,
    showLabel: PropTypes.bool,
  };

  static defaultProps = {
    name: undefined,
    className: "",
    checked: false,
    onChange: () => null,
    disabled: false,
    children: null,
    showLabel: true,
  };

  render() {
    const { className, label, value, name, checked, disabled, children, onChange, showLabel } = this.props;

    return (
      <span className={`et--radio ${className}`}>
        <input
          id={label}
          type="radio"
          className={classNames("et--radio--input", { "is-disabled": disabled }, className)}
          name={name}
          value={value}
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          aria-label={label}
        />
        {showLabel && (
          <label className="et--radio--label" htmlFor={label}>
            {children || label}
          </label>
        )}
      </span>
    );
  }
}

export default Radio;
